import { theme } from '@Guidelines/Theme/theme';
import useDocumentViewer from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Providers/DocumentViewerProvider/useDocumentViewer';
import { css } from '@emotion/react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';

const panelStyle = css`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1rem;
`;

const messageStyle = css`
	margin: 0;
	padding: 1rem;
	align-self: stretch;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.medium};
	line-height: 1.6;
	color: ${theme.colors.inkSecondary};
`;

const MESSAGE_BY_REASON = Object.freeze({
	field: "Ce champ n'apparaît plus dans le document : la partie ou l'élément qui le contenait a été masqué ou supprimé.",
	item: "Cet élément n'est plus dans le document.",
	condition: "Ce texte n'est plus affiché : la valeur dont il dépend a changé.",
} satisfies Record<'field' | 'item' | 'condition', string>);

type Props = {
	readonly reason: 'field' | 'item' | 'condition';
};

/** What the sidebar shows once the object it was on is no longer in the document. */
const GonePanel: React.FC<Props> = ({ reason }) => {
	const { nextPendingField, goToAdjacentPending } = useDocumentViewer();

	const handleNext = React.useCallback(() => {
		goToAdjacentPending('next');
	}, [goToAdjacentPending]);

	return (
		<div css={panelStyle}>
			<p css={messageStyle}>{MESSAGE_BY_REASON[reason]}</p>
			<ConditionalLoader data={nextPendingField}>
				<Button type="button" label="Prochain à vérifier" onClick={handleNext} />
			</ConditionalLoader>
		</div>
	);
};

export default GonePanel;
